/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ScorecardTemplateSummary
 */
export interface ScorecardTemplateSummary {
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSummary
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ScorecardTemplateSummary
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScorecardTemplateSummary
     */
    parameters?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScorecardTemplateSummary
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScorecardTemplateSummary
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSummary
     */
    ruleCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScorecardTemplateSummary
     */
    isDraft?: boolean;
}

/**
 * Check if a given object implements the ScorecardTemplateSummary interface.
 */
export function instanceOfScorecardTemplateSummary(value: object): boolean {
    return true;
}

export function ScorecardTemplateSummaryFromJSON(json: any): ScorecardTemplateSummary {
    return ScorecardTemplateSummaryFromJSONTyped(json, false);
}

export function ScorecardTemplateSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardTemplateSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'ruleCount': json['ruleCount'] == null ? undefined : json['ruleCount'],
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
    };
}

export function ScorecardTemplateSummaryToJSON(value?: ScorecardTemplateSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'parameters': value['parameters'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'ruleCount': value['ruleCount'],
        'isDraft': value['isDraft'],
    };
}

